export enum EmployeeProfileTypes {
  sepIra = 'SEP IRA (employee)',
}
